import { Container, Stack, Title, Text, Button } from "@mantine/core";
import { useCallback, useState } from "react";
import Recaptcha from "react-google-recaptcha";
// import { verificarCaptcha } from "@/modules/recaptcha/functions";

type PaginaConfirmacaoProperties = {
  votos: { categoria: string; empresa: string }[];
  onConfirmar: () => void;
};

const SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY as string;
const IS_DEVELOPMENT = import.meta.env.DEV;

const PaginaConfirmacao = ({ votos, onConfirmar }: PaginaConfirmacaoProperties) => {
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const [verificando, setVerificando] = useState(false);
  const handleCaptcha = useCallback((token: string | null) => {
    setCaptchaToken(token);
  }, []);

  const handleConfirmar = useCallback(() => {
    // if (IS_DEVELOPMENT) {
    //    onConfirmar();
    //   return;
    // }

    if (!captchaToken) return;

    setVerificando(true);

    try {
      //const response = await verificarCaptcha({ token: captchaToken });
      //if (response.data.success) {
      onConfirmar();
      // } else {
      //   alert("Verificação do reCAPTCHA falhou.");
      // }
    } catch {
      alert("Erro ao verificar reCAPTCHA. Tente novamente.");
    } finally {
      setVerificando(false);
    }
  }, [captchaToken, onConfirmar]);

  const handleConfirmarClick = useCallback(() => {
    void handleConfirmar();
  }, [handleConfirmar]);

  return (
    <Container size="sm" py="xl">
      <Stack align="center">
        <Title order={3}>Confirmação do Voto</Title>

        <Text>Você está prestes a confirmar seu voto para</Text>
        <Stack>
          {votos.map((voto, index) => (
            <Text key={index}>
              <strong>{voto.empresa}</strong> na categoria <strong>{voto.categoria}</strong>
            </Text>
          ))}
        </Stack>
        {!IS_DEVELOPMENT && SITE_KEY && <Recaptcha sitekey={SITE_KEY} onChange={handleCaptcha} />}

        <Button
          mt="md"
          onClick={handleConfirmarClick}
          disabled={!IS_DEVELOPMENT && (!captchaToken || verificando)}
          loading={verificando}
        >
          Confirmar Voto
        </Button>
      </Stack>
    </Container>
  );
};

export default PaginaConfirmacao;
